import PropTypes from 'prop-types';
import React from 'react';
import { useRefinementList } from 'react-instantsearch';

export const MwobFilter = ({ attribute, label }) => {
    const { items, refine } = useRefinementList({ attribute });
    const trueRefinement = items.find(item => item.label === 'true');

    if (!trueRefinement) {
        return null;
    }

    return (
        <li className="ais-RefinementList-item">
            <label className="ais-RefinementList-label">
                <input
                    className="ais-RefinementList-checkbox"
                    type="checkbox"
                    checked={trueRefinement.isRefined}
                    onChange={() => {
                        refine(trueRefinement.value);
                    }}
                />
                <span className="ais-RefinementList-labelText">{label}</span>{' '}
                <span className="ais-RefinementList-count">{trueRefinement.count}</span>
            </label>
        </li>
    );
};

MwobFilter.propTypes = {
    attribute: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};
